export default "__VITE_ASSET__DvEPddwk__"